<div class="recent-items">
  <div class="item d-flex align-items-center">
    <img loading="lazy" [src]="
    metadata?.gender === this.genderEnum.MALE ? 
    (metadata?.waistHipIndexHigh < 0.78 ? '/../../../assets/images/icons/icons8-pera-96.png' :
    metadata?.waistHipIndexHigh > 0.94 ? '/../../../assets/images/icons/icons8-apple-100.png' :  
    '/../../../assets/images/icons/icons8-situacion-del-hombre-96.png'
    ): 
    metadata?.gender === this.genderEnum.FEMALE ? 
    (metadata?.waistHipIndexHigh < 0.71 ? '/../../../assets/images/icons/icons8-pera-96.png' :
    metadata?.waistHipIndexHigh > 0.84 ? '/../../../assets/images/icons/icons8-apple-100.png' :  
    '/../../../assets/images/icons/icons8-woman-100.png') : '' " alt="">
    <div class="ml-xs">
      <p class="text-info">
        {{
          metadata?.gender === this.genderEnum.MALE ? 
          (metadata?.waistHipIndexHigh < 0.78 ? 'CUERPO ANDROIDE' :
           metadata?.waistHipIndexHigh > 0.94 ? 'CUERPO GINOIDE' :  
           'CUERPO NORMAL'
          ): 
          metadata?.gender === this.genderEnum.FEMALE ? 
          (metadata?.waistHipIndexHigh < 0.71 ? 'CUERPO ANDROIDE' :
          metadata?.waistHipIndexHigh > 0.84 ? 'CUERPO GINOIDE' :  
          'CUERPO NORMAL') : ''
        }}
      </p>
    </div>
  </div>
</div>